import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { OLAF, LORAX, CANDY_APPLE } from 'HubStyleTokens/colors';
import { EARTH_LAYER } from 'HubStyleTokens/sizes';
import UIClickable from 'UIComponents/button/UIClickable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
const STYLE = {
  container: {
    position: 'relative',
    zIndex: '1'
  },
  fullHeight: {
    height: '100%'
  },
  gradient: {
    backgroundImage: `linear-gradient(to right, ${CANDY_APPLE}, ${LORAX} )`,
    color: OLAF
  }
};
const StyledOverlay = styled(UIOverlay).withConfig({
  displayName: "VideoPlayer__StyledOverlay",
  componentId: "sc-1jl7mfd-0"
})(["&&{z-index:", ";}"], EARTH_LAYER);

/*
TODO refactor to core
*/
export default function VideoPlayer({
  onTrackInteraction,
  playAnalyticsId,
  videoUrl
}) {
  const video = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);
  return /*#__PURE__*/_jsxs("figure", {
    className: "video-player",
    style: STYLE.container,
    children: [/*#__PURE__*/_jsx("video", {
      ref: video,
      controls: !showOverlay,
      preload: "metadata",
      width: "100%",
      poster: `${videoUrl}\\medium.jpg`,
      onEnded: () => onTrackInteraction('complete video'),
      children: /*#__PURE__*/_jsx("source", {
        src: videoUrl,
        type: "video/mp4"
      })
    }), showOverlay && /*#__PURE__*/_jsx(UIClickable, {
      "data-hs-analytics-id": playAnalyticsId,
      onClick: event => {
        event.preventDefault();
        onTrackInteraction('start video');
        setShowOverlay(false);

        if (video && video.current) {
          video.current.play().catch(error => console.error(`Unable to play video with url: ${videoUrl}`, error));
        }
      },
      children: /*#__PURE__*/_jsx(StyledOverlay, {
        className: "p-all-0",
        contextual: true,
        use: "dark",
        width: "100%",
        children: /*#__PURE__*/_jsx(UIFlex, {
          direction: "column",
          align: "center",
          justify: "center",
          style: STYLE.fullHeight,
          children: /*#__PURE__*/_jsx(UIFlex, {
            direction: "column",
            justify: "center",
            style: STYLE.fullHeight,
            children: /*#__PURE__*/_jsx(UIIconCircle, {
              name: "playerPlay",
              color: OLAF,
              backgroundColor: LORAX,
              borderWidth: 0,
              size: 24,
              style: STYLE.gradient
            })
          })
        })
      })
    })]
  });
}